const version = document.getElementById('BuildVersion')?.innerText
const commitIDAndBranch = document.getElementById('commitAndBranch')?.innerText

export const buildInfo = `${version}-${commitIDAndBranch}`

export const isLoggerEnabled = true

export const defaultEventAttributes = {
  url: '/',
  buildInfo,
  qmSession:
    typeof window !== 'undefined' && window.sessionStorage.getItem('qmSession'),
  deviceAppVersion:
    typeof window !== 'undefined' &&
    window.sessionStorage.Channel === 'USBAPP' &&
    window.sessionStorage.getItem('deviceAppVersion'),
  deviceInfo:
    typeof window !== 'undefined' &&
    window.sessionStorage.Channel === 'USBAPP' &&
    window.sessionStorage.getItem('deviceInfo')
}

export const defaultParams = {
  eventType: 'MONEYMOVEMENT',
  eventSubType: 'BillPay-PayeeManagement',
  appId: 'usb-ui-billpay-payeemanagement'
}

export const initConfig = {
  advanced: true,
  isapigeeProxyEnabled: !!(
    typeof window !== 'undefined' &&
    window.sessionStorage &&
    window.sessionStorage.getItem('channelId') === 'TUX'
  ),
  devicesInfo: {
    breakpoints: {
      mobile: 480,
      tablet: 760
    },

    defaultDevice: 'desktop'
  },

  ...defaultParams
}

export const eventSourceDefaultParams = {
  businessFunctionality: 'Manage Billers',
  businessCapability: 'Payee and Billers Management'
}

export const infoConfig = {
  level: 'info',
  eventSource: {
    component: 'Bill Pay Payee Dashboard',
    subComponent: 'Bill Pay Payee Dashboard Initial component',
    stepName: 'Bill Pay Payee Dashboard Initial page Started',
    ...eventSourceDefaultParams
  },

  eventAttributes: {
    ...defaultEventAttributes
  },

  ...defaultParams
}

export const errorDefaultConfig = {
  eventStatus: 'ERROR',
  ...defaultParams
}

const webViewDefaultEventSourceParams = {
  businessFunctionality: 'Manage Billers Handshake of Mobile App',
  businessCapability: 'Payee and Billers Management Mobile App',
  component: 'Bill Pay Payee Dashboard WebView',
  subComponent: 'Bill Pay Payee Dashboard Web View Handlers'
}

export const webViewInfoConfig = ({ eventSource, eventAttributes }) => ({
  level: 'info',
  eventSource: {
    ...webViewDefaultEventSourceParams,
    ...eventSource
  },

  eventAttributes: {
    ...defaultEventAttributes,
    ...eventAttributes
  },

  ...defaultParams
})

export const webViewErrorConfig = ({
  eventSource,
  eventAttributes,
  errorStack,
  exceptionMsg,
  severity = ['HIGH']
}) => ({
  level: 'Error',
  eventSource: {
    ...webViewDefaultEventSourceParams,
    ...eventSource
  },

  eventAttributes: {
    ...defaultEventAttributes,
    ...eventAttributes
  },

  eventStatus: 'ERROR',
  exception: {
    severity: [...severity],
    exceptionCode: 500,
    exceptionMsg: `BillPay Payee Management - error caught while handshaking with IOS Andriod Hanlders .${
      exceptionMsg || ''
    }`,
    dumpAnalysis: errorStack
  },

  ...defaultParams
})

/* functions for kibana logs for onboarding flow */
const isMultiProduct = () => {
  const multiProduct = window.sessionStorage.getItem(
    'DIY_IS_MULTI_PRODUCT_EXT_ONB'
  )
  return (
    multiProduct && (multiProduct.trim() === 'true' || multiProduct === true)
  )
}

const getBusinessCapability = () => {
  let businessCapability = 'EXTENDED_ONBOARDING'
  if (isMultiProduct()) {
    businessCapability += '_MULTI_PRODUCT'
  }
  return businessCapability
}

const isDeeplinkExists = () =>
  window.sessionStorage.getItem('onBoardingDeepLink')

const getDeeplinkSource = () => {
  try {
    const deepLinkObj = isDeeplinkExists()
      ? JSON.parse(isDeeplinkExists())
      : null
    return deepLinkObj ? deepLinkObj[0]?.dlSource : ''
  } catch (e) {
    return ''
  }
}
export const eventSourceDefaultParamsForOnboarding = {
  businessCapability: getBusinessCapability(),
  onBoardingFlow: 'CHECKING',
  dlSource: getDeeplinkSource(),
  channel:
    typeof window !== 'undefined' && window.sessionStorage.getItem('Channel')
}
